import React from 'react'
import { OverlayTrigger, Tooltip } from 'react-bootstrap'

export default function ToolTip({ title, children, id, placement = "bottom-start" }) {
    return (
        <OverlayTrigger placement={placement} delayShow={300} delayHide={150} overlay={<Tooltip id={id} className="fs-5">{title}</Tooltip>}>
            {children}
        </OverlayTrigger>
    )
}
